export const modalOptions = ["link"] as const;

export type ModalOption = (typeof modalOptions)[number];

export const formatFeatures = [
  "bold",
  "italic",
  "underline",
  "link",
  "textStyle",
  "blockquote",
  "lists",
  "indent",
] as const;

export type FormatFeature = (typeof formatFeatures)[number];

// "lists" covers bulleted and numbered
export type FeatureOptions = Partial<Record<FormatFeature, boolean>>;

// existing features default on, new block formats opt in
export const defaultFeatureOptions: Record<FormatFeature, boolean> = {
  bold: true,
  italic: true,
  underline: true,
  link: true,
  textStyle: false,
  blockquote: false,
  lists: false,
  indent: false,
};

export const resolveFeatureOptions = (
  featureOptions?: FeatureOptions,
): Record<FormatFeature, boolean> => ({
  ...defaultFeatureOptions,
  ...featureOptions,
});

// client message set, indent renders as non-breaking spaces in email
export const richMessageFeatures: FeatureOptions = {
  textStyle: true,
  blockquote: true,
  lists: true,
  indent: true,
};
